import { ShareLinkMessengerMessage } from './type/ShareLinkMessengerMessage';
import match from '../expression/match';
import isNewUrlMessage from './is-new-url-message';
import isLoadLinkMessage from './is-load-link-message';
import onShareLinksMessengerNewUrl from '../action/on-slm-new-url';
import onShareLinksMessengerLoadLink from '../action/on-slm-load-link';

type T = (message: ShareLinkMessengerMessage) => void;

const f: T = (message) => {
    match(message)
        .on(isNewUrlMessage, onShareLinksMessengerNewUrl)
        .on(isLoadLinkMessage, onShareLinksMessengerLoadLink)
        .otherwise(() => undefined);
};

export default f;
